module.exports = __webpack_public_path__ + "img/login-image-cover.f61b8c44.gif";